module.exports = __webpack_public_path__ + "static/feature_automatization-5202006ac60c652aabd91bcd7dff3ebd.png";